import React, {  useContext, useEffect, useState } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import './progressbar.module.css'
import tick from '../assets/Vector 138.png'

// import BlackStar from "../../assets/toursImages/Star-2.png"
import Star from "../assets/Union.png"
import FilterPng from "../assets/Vector-45.png"
import mousepointer from "../assets/mouse-pointer-svgrepo-com 1.png"
import WishList from "../assets/Group 1618873637.png"
import style from "../components/progressbar.module.css"
import { Range } from 'react-range';
import { getTrackBackground } from 'react-range';
import Select, { components } from 'react-select';
import LocationArrow from "../assets/route 2.svg"
import RightMark from "../assets/Vector 128.png"
import fac from "../assets/Group 1008.png"
import purpleClock from "../assets/duration dark purple.svg"
import SafePng from "../assets/security.svg fill.png"
import TripPng from "../assets/support.svg fill.png"
import RefundPng from "../assets/policy.svg.png"
import venderPng from "../assets/3d-render-man-relax-practice-yoga-meditation 1.png"
import PlanningPng from "../assets/pack-svgrepo-com 1.png"
import SortIcon from "../assets/Vector-45.png"
import TravelGlobePng from "../assets/travel-svgrepo-com (1) 1.png"
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai'
import { mockData } from './allPackagesData'
import Tourspagination from "../components/Tourspagination"
import Skeleton from "../skeleton/skeleton"
import { CountryName } from '../pages/TourSearchPage'
import NotFoundImg from '../assets/DataNotFound-Img.avif'
import BASE_URL from '../config'; // Adjust the import path as necessary



const Progressbars=() =>{
  const { country } = useContext(CountryName);
  const [showMorePlaces, setShowMorePlaces] = useState({}); // State for places
  const [showMoreCities, setShowMoreCities] = useState({}); // State for cities
  const [wishlist, setWishlist] = useState({});
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0); // Current page state
  const itemsPerPage = 5; // 5 packages per page
  const STEP = 1000; // Step size for the range
  const MIN = 1000;  // Minimum value for the range
  const MAX = 200000;
  const MinDuration=0;
  const MaxDuration=30;
  const StepDuration=1;
  const [duration, setDuration] = useState([0,12]);
  const [budgetValues, setBudgetValues] = useState([1000, 200000]);
  const [filteredData, setFilteredData] = useState([]);
  const [hasFlights, setHasFlights] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const searchTerm = location.state?.searchTerm || "";
  const budget = location.state?.budget || 0; // D
  const [sortOptionLowToHigh, setSortOptionLowToHigh] = useState('option1'); // Default to Price-Low to High
  const [showWishlist, setShowWishlist] = useState(false);
  const [expandedCities, setExpandedCities] = useState({});
  const [favorites, setFavorites] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState('all');
  

  const handleShowMoreCitiesClick = (pkgID) => {
    setExpandedCities((prev) => ({
      ...prev,
      [pkgID]: !prev[pkgID], // Toggle visibility
    }));
  };

  const handleCategoryClick = (category) => setSelectedCategory(category);

  const selectCountryStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "20px", // Rounded corners
      boxShadow: "none", // Remove box shadow
      paddingRight: "0px", // Remove extra padding
      border: "1px solid rgba(84, 28, 156, 1)", // Purple border
    }),
    
    indicatorSeparator: () => ({
      display: "none", // Remove separator line between text & dropdown arrow
    }),
  
    singleValue: (provided) => ({
      ...provided,
      color: "black", // Text color remains black
    }),
  
    menu: (base) => ({
      ...base,
      borderRadius: "20px", // Rounded corners for the dropdown menu
      overflow: "hidden", // Prevents sharp edges
      border: "1px solid rgba(84, 28, 156, 1)", // Keep theme consistency
    }),
  
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isSelected
        ? "rgba(84, 28, 156, 1)" // Purple when selected
        : isFocused
        ? "rgba(84, 28, 156, 0.2)" // Lighter purple on hover
        : "white",
      color: isSelected ? "white" : "black",
      borderRadius: "4px", // Rounded corners for options
      margin: "2px", // Add spacing between options
    }),
  };
  
  const selectFilterStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid rgba(84, 28, 156, 1)",  // Border color
      borderRadius: '20px',                      // Rounded corners
      boxShadow: 'none',                         // No shadow
      textAlign: 'center',                       // Center text alignment (though this is not enough by itself)
      display: 'flex',                           // Ensure flexbox for centering
      justifyContent: 'center',   
      paddingLeft:"30px",  
      fontSize:"13px"             // Horizontally center the content
    }),
    indicatorSeparator: () => ({
      display: 'none',                           // Remove separator line
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: 'white', // No background change on hover
      color: 'black', // Keep the text color static
      cursor: 'default', // No pointer change on hover
      ':hover': {
        backgroundColor: 'white', // Disable hover effect
      },
      padding:"4px",
      fontSize:"10px",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure the menu appears above other elements
      fontSize:"13px",
      width:"150px",
      margin:"4px",
      paddingLeft:"24px"
    }),
  };
  const FilterOptions = [
    {
      label: 'Sort By',
      options: [
        { value: 'option1', label: 'Price-Low to High' },
          { value: 'option2', label: 'Price-High to Low' },
          { value: 'option3', label: 'Rating-High to Low' },
          { value: 'option4', label: 'Rating -Low to High' },
          { value: 'option4', label: 'Duration -High To Low' },
          { value: 'option5', label: 'Duration -Low To High' },
      ],
    },
  ];

  const themeOptions = [
    { value: 'vigovia', label: 'Vigovia Spcl.' },
    { value: 'honeymoon', label: 'Honeymoon' },
    { value: 'pilgrim', label: 'Pilgrim Dest' },
    { value: 'beach', label: 'Beach Spots' },
    { value: 'adventure', label: 'Adventure Loc.' },
  ];
  const CustomOption = (props) => {
    return (
      <div
        onClick={() => props.selectOption(props.data)} // Use selectOption from props
        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
      >
        <input
          type="radio"
          name="filter-options"
          value={props.data.value}
          checked={props.isSelected}
          readOnly // Make the radio button read-only
        />
        <label style={{ marginLeft: '5px' }}>{props.data.label}</label>
      </div>
    );
  };
  const CustomMenu = (props) => {
    return (
      <components.Menu {...props}>
        {/* Render sections */}
        {FilterOptions.map((group) => (
          <div key={group.label}>
            <div style={{ padding: '10px', fontWeight: 'bold' }}>{group.label}</div> {/* Group Heading */}
            {group.options.map((option) => (
              <CustomOption key={option.value} data={option} {...props} />
            ))}
          </div>
        ))}
      </components.Menu>
    );
  };

  useEffect(() => {
    // Simulating a loading period for demonstration. Adjust as necessary.
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // 2 seconds loading time, you can modify this.

    return () => clearTimeout(timer); // Cleanup timeout when the component unmounts
  }, []);

  const handleBudgetChange = (values) => {
  setBudgetValues(values);
  };

  const handleDurationChange = (values) => {
    setDuration(values); // Update state with the array value
  }

  const handleFlightToggle = () => {
    setHasFlights(prevState => !prevState); // Toggle the flight filter state
  };
  const extractDays = (durationStr) => {
    const match = durationStr.match(/(\d+)D/); // Extract days from 'XD/YN' format
    return match ? parseInt(match[1], 10) : 0; // Return the number of days, or 0 if not found
  };

  const [tours, setTours] = useState([]); // Store API data

  const defaultTours = [
    {
      ID: 1,
      CreatedAt: "2024-01-01T00:00:00Z",
      UpdatedAt: "2024-01-01T00:00:00Z",
      DeletedAt: null,
      Name: "Classic European Adventure",
      Description: "A 10-day tour covering the best of Europe, including France, Italy, and Switzerland.",
      NumberOfDays: 10,
      NumberOfNights: 9,
      BestMonthsToVisit: "May, June, September",
      Type: "Family",
      TourCategory: "Luxury",
      Inclusions: "Accommodation, Meals, Sightseeing, Transportation, Guided Tours, Insurance",
      Exclusions: "Personal expenses, Visa fees, Flights",
      TotalKMSCovered: 1200,
      EstimatedPopularity: 88,
      InsuranceIncluded: true,
      VisaProvision: true,
      ForexProvision: true,
      TourDetails: [],
      TourImages: [],
      TourTags: [
        {
          ID: 1,
          CreatedAt: "2024-01-01T00:00:00Z",
          UpdatedAt: "2024-01-01T00:00:00Z",
          DeletedAt: null,
          Name: "Family",
          Description: "Perfect for family vacations",
          TourID: 1,
        },
      ],
      TourMajorAttractions: [
        {
          ID: 1,
          CreatedAt: "2024-01-01T00:00:00Z",
          UpdatedAt: "2024-01-01T00:00:00Z",
          DeletedAt: null,
          Name: "Colosseum",
          Description: "Explore the ancient Roman amphitheater.",
          TourID: 1,
        },
      ],
      TourPlaces: [
        {
          ID: 1,
          CreatedAt: "2024-01-01T00:00:00Z",
          UpdatedAt: "2024-01-01T00:00:00Z",
          DeletedAt: null,
          City: "Rome",
          Country: "Italy",
          TourID: 1,
        },
        {
          ID: 1,
          CreatedAt: "2024-01-01T00:00:00Z",
          UpdatedAt: "2024-01-01T00:00:00Z",
          DeletedAt: null,
          City: "Venice",
          Country: "Italy",
          TourID: 1,
        },
        {
          ID: 1,
          CreatedAt: "2024-01-01T00:00:00Z",
          UpdatedAt: "2024-01-01T00:00:00Z",
          DeletedAt: null,
          City: "Milan",
          Country: "Italy",
          TourID: 1,
        },
        {
          ID: 1,
          CreatedAt: "2024-01-01T00:00:00Z",
          UpdatedAt: "2024-01-01T00:00:00Z",
          DeletedAt: null,
          City: "Naples",
          Country: "Italy",
          TourID: 1,
        },
      ],
      TourThemes: [
        {
          ID: 1,
          CreatedAt: "2024-01-01T00:00:00Z",
          UpdatedAt: "2024-01-01T00:00:00Z",
          DeletedAt: null,
          Name: "Historical",
          Description: "Explore historical landmarks and heritage sites.",
          TourID: 1,
        },
      ],
      TourHighlights: [
        "Colosseum guided tour",
        "Venice gondola ride",
        "Swiss Alps scenic train journey",
        "Lake Tekapo, Earth and Sky observation"
      ],
    },
    {
      ID: 2,
      CreatedAt: "2024-01-01T00:00:00Z",
      UpdatedAt: "2024-01-01T00:00:00Z",
      DeletedAt: null,
      Name: "Tropical Maldives Escape",
      Description: "A 7-day luxury escape to the Maldives with private villas and all-inclusive services.",
      NumberOfDays: 7,
      NumberOfNights: 6,
      BestMonthsToVisit: "December, January, February",
      Type: "Couple",
      TourCategory: "Luxury",
      Inclusions: "Accommodation, Meals, Snorkeling, Private Beach Access",
      Exclusions: "Personal expenses, Tips, Visa fees",
      TotalKMSCovered: 200,
      EstimatedPopularity: 95,
      InsuranceIncluded: true,
      VisaProvision: true,
      ForexProvision: true,
      TourDetails: [],
      TourImages: [],
      TourTags: [
        {
          ID: 2,
          CreatedAt: "2024-01-01T00:00:00Z",
          UpdatedAt: "2024-01-01T00:00:00Z",
          DeletedAt: null,
          Name: "Honeymoon",
          Description: "Perfect for couples and honeymooners",
          TourID: 2,
        },
      ],
      TourMajorAttractions: [
        {
          ID: 2,
          CreatedAt: "2024-01-01T00:00:00Z",
          UpdatedAt: "2024-01-01T00:00:00Z",
          DeletedAt: null,
          Name: "Underwater Restaurant",
          Description: "Dine in an exotic underwater restaurant with marine life views.",
          TourID: 2,
        },
      ],
      TourPlaces: [
        {
          ID: 2,
          CreatedAt: "2024-01-01T00:00:00Z",
          UpdatedAt: "2024-01-01T00:00:00Z",
          DeletedAt: null,
          City: "Malé",
          Country: "Maldives",
          TourID: 2,
        },
      ],
      TourThemes: [
        {
          ID: 2,
          CreatedAt: "2024-01-01T00:00:00Z",
          UpdatedAt: "2024-01-01T00:00:00Z",
          DeletedAt: null,
          Name: "Luxury",
          Description: "Premium accommodations and exclusive experiences.",
          TourID: 2,
        },
      ],
      TourHighlights: [
        "Underwater Restaurant experience",
        "Private villa stay",
        "Snorkeling with marine life",
        "Sunset cruise on Indian Ocean"
      ],
    },
  ];


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/tour/search?query=${encodeURIComponent(searchTerm)}`);
        const result = await response.json();

        if (result.data && result.data.length > 0) {
          setTours(result.data); 
        } else {
          setTours(defaultTours); 
        }
      } catch (error) {
        console.error("Error fetching tour data:", error);
        setTours(defaultTours); 
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [searchTerm]);


  useEffect(() => {
    if (loading) return;

    const [minBudget, maxBudget] = budgetValues;
    const selectedDuration = duration[0];

    let initialData = showWishlist 
      ? tours.filter(pkg => wishlist[pkg.ID]) 
      : tours;

    const filtered = initialData.filter(pkg => {
      const price = hasFlights && pkg.FlightPrice 
        ? parseInt(pkg.FlightPrice.replace(/[^0-9]/g, ''))
        : 10000; // Set default price if not available

      const pkgDurationDays = pkg.NumberOfDays;

      const countryMatch = !country || 
        pkg.TourPlaces?.some(place => place.Country.toLowerCase().includes(country.toLowerCase()));

      const flightAvailability = !hasFlights || (hasFlights && pkg.FlightPrice);

      let budgetMatch;
      if (budget > 0) {
        budgetMatch = price >= minBudget && price <= Math.min(maxBudget, budget);
      } else {
        budgetMatch = price >= minBudget && price <= maxBudget;
      }

      const durationMatch = selectedDuration === 0 || pkgDurationDays === selectedDuration;

      return budgetMatch && durationMatch && countryMatch && flightAvailability;
    });

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [tours, budgetValues, duration, hasFlights, budget, country, sortOptionLowToHigh, showWishlist, wishlist]);


  // handle viewdetails inside each package

  const defaultPrice = "50999";


  const navigate = useNavigate();

  const handleViewDetails = (tourID) => {
    console.log("Navigating to:", `/tour-details/${tourID}`);
    navigate(`/tour-details/${tourID}`);
  };
  

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedData = filteredData.slice(startIndex, endIndex);
    setData(paginatedData);
  }, [currentPage, filteredData]);

  
  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // Update the current page
  };

  

  const handleShowMorePlacesClick = (id) => {
    setShowMorePlaces((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };



//wish list 

  const capitalizeFirstLetter = (string) => {
    if (!string) return ''; // If the string is empty or undefined
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  
  const handleSortChange = (selectedOption) => {
    setSortOptionLowToHigh(selectedOption.value); // Update sort option state
  };


  // Load wishlist from localStorage on component mount
  useEffect(() => {
    const savedWishlist = localStorage.getItem('packageWishlist');
    if (savedWishlist) {
      setWishlist(JSON.parse(savedWishlist));
    }
  }, []);

  // Handle wishlist toggle
  const handleWishlistClick = (pkgId) => {
    setWishlist((prevState) => {
      const newWishlist = {
        ...prevState,
        [pkgId]: !prevState[pkgId]
      };
      // Save to localStorage
      localStorage.setItem('packageWishlist', JSON.stringify(newWishlist));
      return newWishlist;
    });
  };

  const handleWishlistViewClick = () => {
    if (!showWishlist) {
      setCurrentPage(1); // Reset to first page only when opening wishlist
    }
    setShowWishlist(!showWishlist);
  };

  const [contWidth, setContWidth] = useState('100%');

  useEffect(() => {
    const updateWidth = () => {
      const width = window.innerWidth >= 992 ? '400px' : '100%';
      setBoxWidth(width);
    };

    // Initial check
    updateWidth();

    // Listen to window resize
    window.addEventListener('resize', updateWidth);

    // Cleanup
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  const [boxWidth, setBoxWidth] = useState('100%');

  useEffect(() => {
    const updateWidth = () => {
      const width = window.innerWidth >= 992 ? '400px' : '100%';
      setBoxWidth(width);
    };

    // Initial check
    updateWidth();

    // Listen to window resize
    window.addEventListener('resize', updateWidth);

    // Cleanup
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  const [recomWidth, setRecomWidth] = useState('100%');

  useEffect(() => {
    const updateWidth = () => {
      const width = window.innerWidth >= 992 ? '350px' : '100%';
      setBoxWidth(width);
    };

    // Initial check
    updateWidth();

    // Listen to window resize
    window.addEventListener('resize', updateWidth);

    // Cleanup
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  return (
    <div className="container-fluid" style={{ backgroundColor: "#f9f9f9"}}>


      {/* Filter Section */}
      <div className="container-fluid position-sticky bg-white border-bottom border-1 z-2">
          <div className="d-flex w-100 justify-content-between align-items-center gap-2 flex-wrap overflow-auto" style={{ height: "100px" }}>
            
            {/* Flights Toggle */}
            <div className="d-flex flex-column border-end px-3" style={{ flex: 1, minWidth: "150px" }}>
              <span className="fw-bold pb-1" style={{ fontSize: "15px" }}>Flights</span>
              <label className={`${style.switch} rounded-pill`}>
                <input type="checkbox" checked={hasFlights} onChange={handleFlightToggle} />
                <span className={`${style.slider}`}></span>
              </label>
            </div>

            {/* Duration */}
            <div className="d-flex flex-column border-end px-3" style={{ flex: 1, minWidth: "200px" }}>
              <label className="fw-bold pb-1" style={{ fontSize: "15px" }}>Duration</label>
              <Range
                step={StepDuration}
                min={MinDuration}
                max={MaxDuration}
                values={duration}
                onChange={handleDurationChange}
                renderTrack={({ props, children }) => {
                  const minVal = ((duration[0] - MinDuration) / (MaxDuration - MinDuration)) * 100;
                  const maxVal = ((duration[1] - MinDuration) / (MaxDuration - MinDuration)) * 100;

                  return (
                    <div
                      {...props}
                      style={{
                        height: "6px",
                        width: "100%",
                        borderRadius: "4px",
                        background: '#2f80ed',
                      }}
                    >
                      {children}
                    </div>
                  );
                }}
                renderThumb={({ props }) => (
                  <div
                    {...props}
                    style={{
                      height: "16px",
                      width: "16px",
                      background: "#ffffff", // Matching Flights Toggle
                      boxShadow: '0px 0px 19.5px 0px #00000040',
                      borderRadius: "50%",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  />
                )}
              />
              <div className="d-flex justify-content-between">
                <span style={{ fontSize: "12px" }}>{`${duration[0]} Days`}</span>
                <span style={{ fontSize: "12px" }}>{`${duration[1]} Days`}</span>
              </div>
            </div>

            {/* Budget */}
            <div className="d-flex flex-column border-end px-3" style={{ flex: 1, minWidth: "200px" }}>
              <label className="fw-bold pb-1" style={{ fontSize: "15px" }}>Budget (per person)</label>
              <Range
                step={STEP}
                min={MIN}
                max={MAX}
                values={budgetValues}
                onChange={handleBudgetChange}
                renderTrack={({ props, children }) => {
                  const minVal = ((budgetValues[0] - MIN) / (MAX - MIN)) * 100;
                  const maxVal = ((budgetValues[1] - MIN) / (MAX - MIN)) * 100;

                  return (
                    <div
                      {...props}
                      style={{
                        height: "6px",
                        width: "100%",
                        borderRadius: "4px",
                      background: `#2f80ed`,
                      }}
                    >
                      {children}
                    </div>
                  );
                }}
                renderThumb={({ props }) => (
                  <div
                    {...props}
                    style={{
                      height: "16px",
                      width: "16px",
                      background: "#ffffff", // Matching Flights Toggle
                      boxShadow: '0px 0px 19.5px 0px #00000040',
                      borderRadius: "50%",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  />
                )}
              />
              <div className="d-flex justify-content-between">
                <span style={{ fontSize: "12px" }}>{`₹${budgetValues[0]}`}</span>
                <span style={{ fontSize: "12px" }}>{`₹${budgetValues[1]}`}</span>
              </div>
            </div>

            {/* Hotel Category */}
            <div className="d-flex flex-column border-end px-3" style={{ flex: 1, minWidth: "150px" }}>
              <label className="fw-bold pb-1" style={{ fontSize: "15px" }}>Hotel Category</label>
              <div className="d-flex gap-2">
                {[3, 4, 5].map((star) => (
                  <button key={star} className={`p-1 rounded-2 ${style.hoverEffect}`} style={{ width: "40px", border: "0.8px solid rgba(84, 28, 156, 1)" }}>
                    <span>{star}</span>
                    <img src={Star} alt="star" width={10} />
                  </button>
                ))}
              </div>
            </div>

            {/* Theme Dropdown */}
            <div className="d-flex flex-column border-end px-3" style={{ flex: 1, minWidth: "180px" }}>
              <label className="fw-bold pb-1" style={{ fontSize: "15px" }}>Theme</label>
              <Select 
                placeholder="Select"
                options={themeOptions} 
                styles={{
                  ...selectCountryStyles,
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  

                }}
                menuPortalTarget={document.body}  
              />
            </div>

            {/* Sorting Dropdown */}
            <div className="d-flex flex-column border-end px-3" style={{ flex: 1, minWidth: "180px" }}>
              <label className="fw-bold pb-1" style={{ fontSize: "15px" }}>Sorting</label>
              <div style={{ position: "relative" }}>
                <Select
                  placeholder={
                    <div className="d-flex align-items-center">
                      <img src={SortIcon} alt="Sort Icon" width={14} height={14} className="me-2" />
                      <span>Sorting</span>
                    </div>
                  }
                  options={FilterOptions}
                  components={{ Option: CustomOption, Menu: CustomMenu }}
                  styles={{
                    ...selectFilterStyles,
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (provided, state) => ({
                      ...provided,
                      paddingLeft: "10px", // Space for the icon
                      borderRadius: "20px", // Rounded corners
                      border: "1px solid rgba(84, 28, 156, 1)", // Default purple border
                      boxShadow: state.isFocused ? "0 0 0 1px rgba(84, 28, 156, 0.5)" : "none", // 🔥 Keeps border purple when focused
                      "&:hover": {
                        border: "1px solid rgba(84, 28, 156, 1)", // Ensures purple border on hover
                      },
                    }),
                    menu: (provided) => ({
                      ...provided,
                      width: "250px", // Increased dropdown menu width
                      borderRadius: "10px", // Rounded dropdown corners
                      padding: "0.3em",
                      border: "1px solid rgba(84, 28, 156, 1)",
                    }),
                  }}
                  menuPortalTarget={document.body}  
                  isSearchable={false}
                  onChange={handleSortChange}
                />
              </div>
            </div>

            {/* Wishlist Button */}
            <div className="d-flex flex-column px-3" style={{ flex: 1, minWidth: "150px" , backgroundColor: "#ffffff"}}>
              <button className="border-0 mt-4 p-0 d-flex align-items-center" onClick={handleWishlistViewClick} style={{backgroundColor: "#ffffff"}}>
                <img src={WishList} alt="Wishlist" className="p-1 me-2" />
                <span>Wishlist</span>
              </button>
            </div>


          </div>
      </div>

     {/* All Packages & Sidebar Wrapper */}
      <div className="container mt-5">
        <div className="d-flex flex-column flex-lg-row gap-5 align-items-start">
          
        {/* Packages Section */}
        <div className="flex-grow-1" style={{ maxWidth: contWidth }}>
          <h2>
            {showWishlist ? 'My Wishlist' : (capitalizeFirstLetter(country) || 'All ')}
            <span style={{ color: '#680099', marginBottom: "10px"}}> Packages</span>
          </h2>

          <div className="d-flex gap-2 mb-3 overflow-y-auto">
          {['all', 'honeymoon', 'adventure', 'cultural', 'luxury'].map(category => (
            <button key={category} className="rounded-pill ps-3 pe-3 pt-1 pb-2" 
              style={{width:'120px',fontWeight:'700', border: "1px solid rgba(84, 28, 156, 1)", backgroundColor: selectedCategory === category ? '#541c9c' : 'white', color: selectedCategory === category ? 'white' : 'black'}}
              onClick={() => handleCategoryClick(category)}>
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </button>
          ))}
          </div>
          
          {showWishlist && filteredData.length === 0 && (
            <div className="text-center mt-5 w-50"></div>
          )}

          <div className="row mt-2">
            <div className="col-12 d-flex flex-wrap gap-3">
              {loading ? (
                Array.from({ length: 3 }).map((_, index) => (
                  <Skeleton height={300} width={400} key={index} />
                ))
              ) : data.length > 0 ? (
                data.map((pkg) => (
                  <div key={pkg.ID} style={{width:'100%'}}>
                    <div>
                      {/* Package Card */}
                      <div className="card d-flex flex-column flex-lg-row align-items-stretch" style={{ width: "100%" }}>
                        {/* Image */}
                        <div className="position-relative">
                          <div className="likebutton position-absolute bg-white p-1 rounded-circle" style={{ left: '15px', top: '15px', cursor: "pointer" }} onClick={() => handleWishlistClick(pkg.ID)}>
                            {wishlist[pkg.ID] ? <AiFillHeart size={20} className="text-danger" /> : <AiOutlineHeart size={20} />}
                          </div>
                          {pkg.image ? (
                            <img src={pkg.image} alt="place" width={400} height={300} style={{ objectFit: "cover" }} />
                          ) : (
                            <div style={{ width: boxWidth,height: '300px', backgroundColor: '#d3d3d3', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', fontWeight: 'bold' }}>
                              No Image Available
                            </div>
                          )}
                        </div>
                  
                      {/* Content */}
                      <div className="p-3 d-flex flex-column justify-content-between" style={{ width: "100%" }}>
                        <h5>{pkg.Name}</h5>

                      {/* Cities */}
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="d-flex align-items-center gap-1" style={{ fontSize: "0.85rem", color: "#333" }}>
                          <img 
                            src={mousepointer} 
                            alt="icon" 
                            width="14" 
                            height="14" 
                            className="me-1"
                            style={{ filter: "invert(39%) sepia(4%) saturate(7%) hue-rotate(314deg) brightness(90%) contrast(85%)" }} 
                          />
                          <span style={{ fontWeight: "500",color:'#777777'}}>
                            {expandedCities[pkg.ID]  
                              ? pkg.TourPlaces.map(p => p.City).join(" > ")  // Show all with " > "
                              : pkg.TourPlaces.slice(0, 2).map(p => p.City).join(" > ") // Show first 2 with " > "
                            }
                          </span>
                        </span>

                        {pkg.TourPlaces.length > 2 && (
                          <span 
                            style={{ cursor: "pointer",color:'#2f80ed' ,whiteSpace: "nowrap", fontSize: "0.85rem" ,fontWeight: "700"}}
                            onClick={() => handleShowMoreCitiesClick(pkg.ID)}
                          >
                            {expandedCities[pkg.ID] ? "Show less" : `+${pkg.TourPlaces.length - 2} more`}
                          </span>
                        )}
                      </div>
                        {/* Inclusions */}
                        <div className="d-flex flex-wrap gap-2">
                          {pkg.Inclusions && 
                            pkg.Inclusions.split(", ").map((inclusion, index) => (
                              <span key={index} className="rounded-pill px-3 py-2 d-flex align-items-center" style={{ backgroundColor: "#FBF4FF", fontSize: "small" }}>
                                <span style={{ color: "#541C9C", marginRight: "10px" }}><img style={{width:'15px'}} src={tick}></img></span> {inclusion}
                              </span>
                            ))
                          }
                        </div>

                      {/* Additional Info */}
                        <div className="d-flex flex-wrap gap-2 mt-2">
                          {pkg.VisaProvision && (
                            <span className="rounded-pill px-3 py-2 d-flex align-items-center" style={{ backgroundColor: "#EAEAEA", color: "#777777", fontWeight: "bold", fontSize: "small"  }}>
                               <i className="bi bi-exclamation-circle-fill me-2" style={{ color: '#6c757d' }}></i> Visa
                            </span>
                          )}
                          {pkg.FlightProvision && (
                            <span className="rounded-pill px-3 py-2 d-flex align-items-center" style={{ backgroundColor: "#EAEAEA", color: "#777777", fontWeight: "bold", fontSize: "small"  }}>
                              <i className="bi bi-exclamation-circle-fill me-2"></i> International Flights
                            </span>
                          )}
                          {pkg.ForexProvision && (
                            <span className="rounded-pill px-3 py-2 d-flex align-items-center" style={{ backgroundColor: "#EAEAEA", color: "#777777", fontWeight: "bold", fontSize: "small"  }}>
                              <i className="bi bi-exclamation-circle-fill me-2"></i> Forex
                            </span>
                          )}
                        </div>

                        <hr className="my-1" style={{ backgroundColor: "#D9D9D9", height: "2px" }} />
                        {/* Duration, Price & View Details */}
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="fw-bold"><i className="bi bi-clock-fill" style={{ color: "#541C9C" }}></i> {pkg.NumberOfDays}D / {pkg.NumberOfNights}N</span>
                          <div className="text-center">
                            <span style={{fontWeight:'800'}} className="fw-bold">₹{pkg.price || defaultPrice}</span>
                            <div style={{ fontSize: "small" }}>per person</div>
                          </div>
                          <button onClick={() => handleViewDetails(pkg.ID)} className="p-2 rounded-pill border-0 text-white fw-bold" style={{ backgroundColor: "#541C9C" }}>
                            View Details
                          </button>
                        </div>
                        </div>
                      </div>
                    </div>
                          
                

                  {pkg.TourHighlights && (
                    <div
                      style={{
                        backgroundColor: '#fbf4ff',
                        color: '#777777',
                        fontWeight: '500',
                        width: '95%',
                        padding: '10px',
                        borderRadius: '10px',
                        boxShadow: '8px 10px 23.1px 0px #00000008',
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        setShowMorePlaces((prev) => ({
                          ...prev,
                          [pkg.ID]: !prev[pkg.ID]
                        }))
                      }
                    >
                      {showMorePlaces[pkg.ID] ? (
                        <div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span style={{ color: '#541C9C', fontWeight: 700, fontSize: '13px' }}>
                              <b>Tour Highlights</b>
                            </span>
                            <span style={{ color: '#541C9C', fontWeight: 700, fontSize: '13px' }}>
                              Show less
                            </span>
                          </div>
                          <ul style={{ margin: '10px 0 0 0', paddingLeft: '18px' }}>
                            {pkg.TourHighlights.map((point, idx) => (
                              <li key={idx}>{point}</li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <li style={{ marginTop: '8px' }}>{pkg.TourHighlights[0]}</li>
                          <span style={{ color: '#541C9C', fontWeight: 700, fontSize: '13px', marginLeft: '16px' }}>
                            {pkg.TourHighlights.length > 1 ? `+${pkg.TourHighlights.length - 1} more` : ''}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                  </div>
                ))
                
              ) : (
                <div className="text-center mt-4">
                  <h2>No Packages Found</h2>
                </div>
              )}
            </div>
          </div>

          
        </div>

        

 

        {/* Sidebar - Why Choose Vigovia */}
        <div className="sidebar p-3 rounded mt-5 mb-5 shadow-sm bg-white" style={{ width: setRecomWidth, flexShrink: 0, alignSelf: "start" }}>
          <h4 className='pt-2 pb-4 fw-bold'>Why Choose <span style={{ color: 'rgba(139, 9, 219, 1)' }}>Vigovia?</span></h4>
          <div className='d-flex flex-column gap-4'>
            <div><img src={SafePng} alt='Safe' width={26} /><span className='ps-3 fw-bold' style={{ fontSize: "13px" }}>Safe and secure trip</span></div>
            <div><img src={TripPng} alt='Trip Assistance' width={26} /><span className='ps-3 fw-bold' style={{ fontSize: "13px" }}>Trip assistance throughout journey</span></div>
            <div><img src={RefundPng} alt='Refund Policy' width={26} /><span className='ps-3 fw-bold' style={{ fontSize: "13px" }}>Easy refund policy</span></div>
            <div><img src={venderPng} alt='Vendors' width={26} /><span className='ps-3 fw-bold' style={{ fontSize: "13px" }}>Verified vendors</span></div>
            <div><img src={PlanningPng} alt='Planning' width={26} /><span className='ps-3 fw-bold' style={{ fontSize: "13px" }}>We do the planning, you do the packing</span></div>
            <div><img src={TravelGlobePng} alt='Travel Globe' width={26} /><span className='ps-3 fw-bold' style={{ fontSize: "13px" }}>One stop for all inclusive end-to-end services</span></div>
          </div>
        </div>
        </div>
      </div>

    </div>
    
  )
}

export default Progressbars;


